import { useTheme } from "styled-components";
import Progress from "antd/es/progress";

interface QuotaProgressBarProps {
  percent?: number;
}

const QuotaProgressBar = ({ percent }: QuotaProgressBarProps) => {
  const theme = useTheme();

  const isDarkMode = theme.isDarkMode;
  const strokeColor = isDarkMode
    ? { from: "#7A90BF", to: "#6ADAFB" }
    : { from: "#B3C9FB", to: "#3272FE" };

  return (
    <Progress
      strokeColor={strokeColor}
      showInfo={false}
      percent={percent}
      style={{ marginBottom: 10 }}
      trailColor={isDarkMode ? "#1D2A52" : "#EAECF1"}
    />
  );
};

export default QuotaProgressBar;
